module.exports = __webpack_public_path__ + "static/img/login-r.1ad6842.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/image/login-r.png
// module id = uqqO
// module chunks = 1